// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-OxMvI";
var _4 = "title-HqOPX";
var _5 = "icon-VMp1I";
var _6 = "text-taBo1";
var _7 = "image-1BUfB";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "title", _5 as "icon", _6 as "text", _7 as "image" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "title": _4, "icon": _5, "text": _6, "image": _7 }
